import {PaginatedRequest} from "../../../common/api/models/paginated";

export class Pagable implements PaginatedRequest {
    page: number = 0;
    size: number = 10;
    sort: string;
}
